export default {
  brand: 'AllChinaBuy Spreadsheet',
  nav: {
    home: 'Startseite',
    categories: 'Kategorien',
    guide: 'Spreadsheet-Guide',
    guides: 'Guides',
    about: 'Über uns',
    sheet: 'AllChinaBuy Sheet',
    faq: 'FAQ',
    collapse: 'Einklappen',
    expand: 'Ausklappen',
  },
  lang: {
    label: 'Sprache',
    en: 'English',
    fr: 'Français',
    da: 'Dansk',
    de: 'Deutsch',
  },
  cta: {
    spreadsheet: 'AllChinaBuy Spreadsheet',
    buyNow: 'Jetzt kaufen',
    explore: 'Spreadsheet entdecken',
    browse: 'Kategorien durchsuchen',
    readGuide: 'Guide lesen',
    backHome: 'Zurück zur Startseite',
    allCategories: 'Alle Kategorien',
  },
  disclosure:
    'Diese Website ist eine unabhängige Informationsquelle und weder mit AllChinaBuy verbunden noch von AllChinaBuy unterstützt. Wir können eine Provision aus qualifizierten Käufen erhalten, die über Links auf dieser Website getätigt werden.',
  footer: {
    tagline:
      'Ihr unabhängiger Leitfaden, um Produkte zu finden, die Qualität zu prüfen und mit dem AllChinaBuy-Spreadsheet smarter einzukaufen.',
    quickLinks: 'Schnellzugriff',
    categoriesTitle: 'Kategorien',
    resources: 'Ressourcen',
    guide: 'Spreadsheet-Guide',
    safety: 'Sicherheit & Offenlegung',
    copyright: '© 2026 AllChinaBuy Spreadsheet. Alle Rechte vorbehalten.',
    madeWith: 'Gemacht für smarteres Einkaufen.',
  },
};